<template>
  <div>
    <v-btn text @click.stop="openThemeCreateDialog">Создать тему</v-btn>
    <v-btn v-if="$route.params.course_id" text @click.stop="openImportThemeDialog">Импорт</v-btn>
  </div>
</template>

<script>
import {BUS} from "~/plugins/bus";

export default {
  name: "ThemeAction",
  methods: {
    openThemeCreateDialog() {
      BUS.$emit('openThemeCreateDialog')
    },
    openImportThemeDialog() {
      BUS.$emit('openImportThemeDialog')
    },
  }
}
</script>

<style scoped>

</style>